import React from 'react'

import './styles.scss'

import mainImg from './img/main.png'

import { IntroProps } from '../types'

import { CheckImagesLoaded } from '../utils/CheckImagesLoaded'

const Intro = ({
  coupleData: { coupleSingleName, weddingDate },
  buttonMessage,
  warningMessage,
  locale = 'pt-BR',
  background,
  delay = 0,
  onSkipIntro,
  onLoad,
}: IntroProps) => {
  const date = new Date(weddingDate.timestamp)
  const day = new Intl.DateTimeFormat(locale, { day: '2-digit' }).format(date)
  const month = new Intl.DateTimeFormat(locale, { month: 'short' }).format(date)
  const year = new Intl.DateTimeFormat(locale, { year: 'numeric' }).format(date)

  return (
    <CheckImagesLoaded delay={delay} onLoad={onLoad} className="intro151">
      <div className="bp2-intro151mobile anima-word-break ">
        <div className="bp2-mainbackground">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="bp2-mask"></div>
        <div className="bp2-button-layout-container">
          <div className="bp2-button">
            <div
              className="bp2-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp2-button1" onClick={onSkipIntro}>
              <div className="bp2-button2"></div>
              <div className="bp2-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp2-content-layout-container">
          <div className="bp2-content">
            <img src={mainImg} className="bp2-bg151ok" />
            <div className="bp2-date bp2-intro151-anima-animate-enter">
              <div className="bp2-rectangle"></div>
              <div className="bp2-daymonthyear">
                {locale === 'en-US' ? (
                  <>
                    {month.toUpperCase()} {day} {year}
                  </>
                ) : (
                  <>
                    {day} {month.toUpperCase()} {year}
                  </>
                )}
              </div>
            </div>
            <div className="bp2-couplesinglenamebr-layout-container">
              <div className="notranslate bp2-couplesinglenamebr anima-valign-text-middle bp2-intro151-anima-animate-enter1">
                {coupleSingleName.bride}
                {!!coupleSingleName.groom && ` & ${coupleSingleName.groom}`}
              </div>
            </div>
            <div className="bp2-wedding bp2-intro151-anima-animate-enter2">
              <div className="bp2-rectangle"></div>
              <div className="bp2-casamentode">CASAMENTO DE</div>
            </div>
          </div>
        </div>
      </div>
      <div className="bp1-intro151desktop anima-word-break ">
        <div className="bp1-mainbackground">
          {typeof background !== 'undefined' && background && (
            <img src={background} className="background-image" />
          )}
        </div>
        <div className="bp1-mask"></div>
        <div className="bp1-button-layout-container">
          <div className="bp1-button">
            <div
              className="bp1-sitedecasamentoe"
              dangerouslySetInnerHTML={{ __html: warningMessage }}
            />
            <div className="bp1-button1" onClick={onSkipIntro}>
              <div className="bp1-button2"></div>
              <div className="bp1-pularintrodu347343o">{buttonMessage}</div>
            </div>
          </div>
        </div>
        <div className="bp1-content-layout-container">
          <div className="bp1-content">
            <img src={mainImg} className="bp1-bg151ok" />
            <div className="bp1-date bp1-intro151-anima-animate-enter">
              <div className="bp1-rectangle"></div>
              <div className="bp1-daymonthyear">
                {locale === 'en-US' ? (
                  <>
                    {month.toUpperCase()} {day} {year}
                  </>
                ) : (
                  <>
                    {day} {month.toUpperCase()} {year}
                  </>
                )}
              </div>
            </div>
            <div className="bp1-couplesinglenamebr-layout-container">
              <div className="notranslate bp1-couplesinglenamebr anima-valign-text-middle bp1-intro151-anima-animate-enter1">
                {coupleSingleName.bride}
                {!!coupleSingleName.groom && ` & ${coupleSingleName.groom}`}
              </div>
            </div>
            <div className="bp1-wedding bp1-intro151-anima-animate-enter2">
              <div className="bp1-rectangle"></div>
              <div className="bp1-casamentode">CASAMENTO DE</div>
            </div>
          </div>
        </div>
      </div>
    </CheckImagesLoaded>
  )
}

export default Intro
